<p-table #dataTable [value]="tableData()" [columns]="_columns()" [globalFilterFields]="globalFilterFields()" [filters]="filters()">
  <ng-template pTemplate="caption">
    <div class="flex justify-content-between align-items-center">
      <h5 class="m-0">Table Data</h5>
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="Search keyword" />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (column of columns; track column) {
      <th [pSortableColumn]="column.field">{{ column.header }} <p-sortIcon [field]="column.field"></p-sortIcon></th>
      }

      <th>Actions</th>
    </tr>
    <tr>
      @for (column of columns; track column) {
      <th>
        <p-columnFilter [type]="getFilterType(column)" [field]="column.field" placeholder="Search" [showMenu]="false"></p-columnFilter>
      </th>
      }
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item let-columns="columns">
    <tr>
      @for (column of columns; track column) {
      <td>
        @if(column.type === 'image'){
        <div class="image-container">
          <img src="{{ item | getPath: column.field }}" alt="Image" class="image" />
        </div>
        } @else {
        <span>{{ item | getPath: column.field}} </span>
        }
      </td>
      }

      <td>
        <div style="display: flex; gap: 2px">
          @for (actionBtn of actions(); track actionBtn) {
          <p-button (click)="selectItem(item, actionBtn)" [icon]="actionBtn.icon" [severity]="actionBtn['severity']" />
          }
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
